<template>
  <div>
    <vf-accordion
      v-for="({ data, id, label, layout = 'grid', expanded }, i) in productDetails"
      :key="i"
      :id
      :class="{ 'b-b': i === productDetails.length - 1 }"
      :open="$feature.allowOpenedDetailsAccordionsOnPDP ? expanded : i === 0"
      :title="label"
      variant="aligned"
    >
      <div class="pb-6 pt-2 text-sm c-grey-20">
        <component
          :is="componentTypes[DETAIL_LAYOUTS.includes(layout) ? layout : 'detailCard']"
          :data
          :title="label"
        />
      </div>
    </vf-accordion>
  </div>
</template>

<script setup lang="ts">
import type { ProductDetails } from '#root/api/clients/product/data-contracts'
import {
  LazyProductAccordionsBulletin,
  LazyProductAccordionsDetailCard,
  LazyProductAccordionsGrid,
  LazyProductAccordionsKeyValue,
  LazyProductAccordionsModalGrid,
  LazyProductAccordionsScale
} from '#components'
import { DETAIL_LAYOUTS } from '#types/product'

defineProps<{
  productDetails: ProductDetails[]
}>()

const componentTypes = {
  bulletin: LazyProductAccordionsBulletin,
  detailCard: LazyProductAccordionsDetailCard,
  grid: LazyProductAccordionsGrid,
  keyValue: LazyProductAccordionsKeyValue,
  modalGrid: LazyProductAccordionsModalGrid,
  scale: LazyProductAccordionsScale
}
</script>
